import { Snackbar } from "@material-ui/core";

import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import BanqueService from "../../../services/Banque";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const DetailBanque = () => {
  const [ribNumber, setRibNumber] = useState("");
  const [bankAndAgenceData, setBankAndAgenceData] = useState([]);
  const [bankName, setBankName] = useState("");
  const [agenceName, setAgenceName] = useState("");
  const [agenceLocalisation, setAgenceLocalisation] = useState("");
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setsuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [selectedBanqueOption, setSelectedBanqueOption] = useState(null);
  const [selectedAgenceOption, setSelectedAgenceOption] = useState(null);
  const [banqueOptions, setBanqueOptions] = useState([]);
  const [ageneOptions, setAgeneOptions] = useState([]);
  const [banqueId, setBanqueId] = useState(0);
  const [agenceId, setAgenceId] = useState(0);

  const [addAgence, setAddAgence] = useState(false);
  const [addBankAndAgence, setAddBankAndAgence] = useState(false);

  useEffect(() => {
    BanqueService.getAllAgenceAndBank(getCurrentUserId())
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "empty") {
          setBankAndAgenceData([]);
        } else {
          setBankAndAgenceData(response.data.success);
          remplissageOption(response.data.success);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      })
      // .finally(() => {
      //   stopLoading();
      // })
  }, []);

  const remplissageOption = (data) => {
    let idBankss = [];
    data.map((element) => {
      if (!idBankss.includes(element.idBank)) {
        idBankss.push(element.idBank);

        setBanqueOptions((prevState) => [
          ...prevState,
          { value: element.idBank, label: element.bankName },
        ]);
      }
    });

    console.log(banqueOptions);
  };

  const isANumber = (input, length) => {
    if (
      input[length - 1] === "0" ||
      input[length - 1] === "1" ||
      input[length - 1] === "2" ||
      input[length - 1] === "3" ||
      input[length - 1] === "4" ||
      input[length - 1] === "5" ||
      input[length - 1] === "6" ||
      input[length - 1] === "7" ||
      input[length - 1] === "8" ||
      input[length - 1] === "9"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onChangeRIBHandler = (event) => {
    let currentInput = event.target.value;
    let lengthCurrentInput = currentInput.length;
    if (
      currentInput.length !== 5 &&
      currentInput.length !== 11 &&
      currentInput.length !== 23
    ) {
      if (isANumber(currentInput, lengthCurrentInput)) {
        setRibNumber(event.target.value);
      } else {
        event.target.value = event.target.value.substring(
          0,
          lengthCurrentInput - 1
        );
      }
    } else {
      event.target.value = event.target.value.concat(" ");
      setRibNumber(event.target.value);
    }
  };
  const onChangeBankNameHandler = (event) => {
    setBankName(event.target.value);
  };

  const onChangeAgenceNameHandler = (event) => {
    setAgenceName(event.target.value);
  };
  const onChangeAgenceLocalisationHandler = (event) => {
    setAgenceLocalisation(event.target.value);
  };

  const onValidAddBankAccount = () => {
    console.log(ribNumber);
    console.log(ribNumber.length);
    console.log(bankName);
    console.log(agenceName);
    let obj = {
      bankName: bankName,
      agenceName: agenceName,
      agenceLocalisation: agenceLocalisation,
      ribNumber: ribNumber,
      banqueId: banqueId,
      agenceId: agenceId,
      userId: getCurrentUserId(),
    };
    console.log(agenceLocalisation);
    if (bankAndAgenceData.length === 0) {
      if (ribNumber.length !== 20) {
        setErrorAlertText("Erreur :le RIB doit être 20 chiffres! ");
        setOpenErrorAlert(true);
      } else if (bankName === "") {
        setErrorAlertText("Erreur :le champ nom de banque est vide! ");
        setOpenErrorAlert(true);
      } else if (agenceName === "") {
        setErrorAlertText("Erreur :le champ nom de l'agence  est vide! ");
        setOpenErrorAlert(true);
      } else if (agenceLocalisation === "") {
        setErrorAlertText("Erreur :le champ localisation est vide! ");
        setOpenErrorAlert(true);
      } else {
        saveDataInBackend(obj);
      }
    } else {
      if ((addBankAndAgence && addAgence) || addBankAndAgence) {
        if (ribNumber.length !== 20) {
          setErrorAlertText("Erreur :le RIB doit être 20 chiffres! ");
          setOpenErrorAlert(true);
        } else if (bankName === "") {
          setErrorAlertText("Erreur :Le champ nom de banque est vide! ");
          setOpenErrorAlert(true);
        } else if (agenceName === "") {
          setErrorAlertText("Erreur :Le champ nom de l'agence  est vide! ");
          setOpenErrorAlert(true);
        } else if (agenceLocalisation === "") {
          setErrorAlertText("Erreur :Le champ localisation est vide! ");
          setOpenErrorAlert(true);
        } else {
          saveDataInBackend(obj);
        }
      } else if (addAgence) {
        if (ribNumber.length !== 20) {
          setErrorAlertText("Erreur :le RIB doit être 20 chiffres! ");
          setOpenErrorAlert(true);
        } else if (agenceName === "") {
          setErrorAlertText("Erreur :Le champ nom de l'agence  est vide! ");
          setOpenErrorAlert(true);
        } else if (agenceLocalisation === "") {
          setErrorAlertText("Erreur :le champ localisation est vide! ");
          setOpenErrorAlert(true);
        } else if (banqueId === 0) {
          setErrorAlertText("Erreur :Aucune banque choisie ! ");
          setOpenErrorAlert(true);
        } else {
          saveDataInBackend(obj);
        }
      } else {
        if (ribNumber.length !== 20) {
          setErrorAlertText("Erreur :le RIB doit être 20 chiffres! ");
          setOpenErrorAlert(true);
        } else if (banqueId === 0) {
          setErrorAlertText("Erreur :Aucune banque choisie ! ");
          setOpenErrorAlert(true);
        } else if (agenceId === 0) {
          setErrorAlertText("Erreur :Aucune agence choisie ! ");
          setOpenErrorAlert(true);
        } else {
          saveDataInBackend(obj);
        }
      }
    }
  };

  const saveDataInBackend = (data) => {
    let banqueNameBacked = "";
    let agenceNameBackend = "";
    let agenceLocalisationBackend = "";

    if (bankName === "") {
      banqueNameBacked = "any";
    } else {
      banqueNameBacked = bankName;
    }

    if (agenceName === "") {
      agenceNameBackend = "any";
    } else {
      agenceNameBackend = agenceName;
    }

    if (agenceLocalisation === "") {
      agenceLocalisationBackend = "any";
    } else {
      agenceLocalisationBackend = agenceLocalisation;
    }
    let newdata = {
      bankName: bankName,
      agenceName: agenceName,
      agenceLocalisation: agenceLocalisation,
      rib: ribNumber,
      banqueId: banqueId,
      agenceId: agenceId,
      idUser: getCurrentUserId(),
      type: 1,
    };
    const object = JSON.stringify(newdata);
    console.log(object, "Objet");
    BanqueService.addBankAccount(object)
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "exist") {
          setInfoAlertText(
            "Info : le code RIB est déja exist dans le systéme "
          );
          setOpenInfoAlert(true);
        } else {
          setsuccessAlertText("Enregistrement avec succés");
          setOpenSuccessAlert(true);
          window.location.href = "/allBanqueAccounts";
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleChangeBanque = (selectedOptionn) => {
    setSelectedBanqueOption();
    setBanqueId(selectedOptionn.value);
    setAgeneOptions([]);
    setAgenceId(0);
    setSelectedAgenceOption(null);

    bankAndAgenceData.map((element) => {
      if (element.idBank === selectedOptionn.value) {
        setAgeneOptions((prevState) => [
          ...prevState,
          { value: element.idAgence, label: element.agenceName },
        ]);
      }
    });
  };

  const addBanqueHandler = () => {
    setAddBankAndAgence(true);
    setAgenceId(0);
    setBanqueId(0);
  };

  const addAgenceHandler = () => {
    setAddAgence(true);
    setAgenceId(0);
  };

  const handleChangeAgence = (selectedOptionn) => {
    setSelectedAgenceOption();
    setAgenceId(selectedOptionn.value);
    //heere

    bankAndAgenceData.map((element) => {
      if (element.idAgence === selectedOptionn.label) {
        setBanqueOptions((prevState) => [
          ...prevState,
          { value: element.idBank, label: element.bankName },
        ]);
      }
    });
  };

  return (
    <section class="content" style={{ marginTop: "2%" }}>
      <div class="row">
        <div class="col-12">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                Ajouter les cordonnées de votre banque
              </h3>
            </div>
            {/* <div className="content-nowrap" style={{ marginTop: "0" }}> */}
        
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-12">
                          <label htmlFor="inputName">RIB bancaire</label>

                          <div className="form-group">
                            <input
                              placeholder="Ajouter RIB "
                              onChange={onChangeRIBHandler}
                              maxlength="20"
                              type="text"
                              id="inputName"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row">
                          {bankAndAgenceData.length === 0 ||
                          addBankAndAgence ||
                          addAgence ? (
                            <>
                              {" "}
                              {(bankAndAgenceData.length === 0 ||
                                addBankAndAgence) && (
                                <div className="form-group" class="col-sm-12">
                                  <label htmlFor="inputName">
                                    Nom de la banque
                                  </label>
                                  <input
                                    placeholder="Ajouter nom de la banque"
                                    onChange={onChangeBankNameHandler}
                                    type="text"
                                    id="inputName"
                                    className="form-control"
                                  />
                                </div>
                              )}
                              {addAgence && !addBankAndAgence && (
                                <>
                                  {" "}
                                  <div class="form-group col-4 col-sm-8">
                                    <div>
                                      <label>Choisir une banque</label>
                                      <Select
                                        value={selectedBanqueOption}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        options={banqueOptions}
                                        onChange={handleChangeBanque}
                                        defaultValue={selectedBanqueOption}
                                        placeholder={"Choisir..."}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="form-group"
                                    class="col-4 col-sm-2"
                                    style={{ marginTop: 32 }}
                                  >
                                    <button
                                      class="btn btn-light "
                                      onClick={addBanqueHandler}
                                    >
                                      <i class="fas fa-plus"></i>
                                      Ajouter
                                    </button>{" "}
                                  </div>{" "}
                                </>
                              )}
                              {(bankAndAgenceData.length === 0 ||
                                addBankAndAgence ||
                                addAgence) && (
                                <>
                                  {" "}
                                  <div className="form-group" class="col-sm-6">
                                    <label htmlFor="inputName">
                                      Ajouter nom de l'agence
                                    </label>
                                    <input
                                      placeholder="Ajouter nom de l'agence"
                                      onChange={onChangeAgenceNameHandler}
                                      type="text"
                                      id="inputName"
                                      className="form-control"
                                    />
                                  </div>
                                  <br />
                                  <div className="form-group" class="col-sm-6">
                                    <label htmlFor="inputName">
                                      Ajouter localisation de l'agence
                                    </label>
                                    <input
                                      placeholder="Ajouter localisation"
                                      onChange={
                                        onChangeAgenceLocalisationHandler
                                      }
                                      type="text"
                                      id="inputName"
                                      className="form-control"
                                    />
                                  </div>{" "}
                                </>
                              )}
                   
                            </>
                          ) : (
                            <>
                              <div class="form-group col-4 col-sm-7">
                                <div>
                                  <label>Choisir une banque</label>
                                  <Select
                                    value={selectedBanqueOption}
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    options={banqueOptions}
                                    onChange={handleChangeBanque}
                                    defaultValue={selectedBanqueOption}
                                    placeholder={"Choisir..."}
                                  />
                                </div>
                              </div>
                              <div
                                className="form-group"
                                class="col-4 col-sm-2"
                                style={{ marginTop: 32 }}
                              >
                                <button
                                  class="btn btn-light "
                                  onClick={addBanqueHandler}
                                >
                                  <i class="fas fa-plus"></i>
                                  Ajouter
                                </button>{" "}
                              </div>

                              <div class="form-group col-4 col-sm-7">
                                <div>
                                  <label>Choisir une agence</label>
                                  <Select
                                    value={selectedAgenceOption}
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    options={ageneOptions}
                                    onChange={handleChangeAgence}
                                    defaultValue={selectedBanqueOption}
                                    placeholder={"Choisir..."}
                                  />
                                </div>
                              </div>

                              <div
                                className="form-group"
                                class="col-4 col-sm-2"
                                style={{ marginTop: 32 }}
                              >
                                <button
                                  class="btn btn-light "
                                  onClick={addAgenceHandler}
                                >
                                  <i class="fas fa-plus"></i>
                                  Ajouter
                                </button>{" "}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button
                          className="btn btn-dark float-right"
                          onClick={onValidAddBankAccount}
                        >
                          Enregistrer
                        </button>
                      </div>
                    </div>
                 

            <Snackbar
              open={openErrorAlert}
              autoHideDuration={2000}
              onClose={handleEroorClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                variant="filled"
                onClose={handleEroorClose}
                severity="error"
              >
                {errorAlertText}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccessAlert}
              autoHideDuration={2000}
              onClose={handleSuccessClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                variant="filled"
                onClose={handleSuccessClose}
                severity="success"
              >
                {successAlertText}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openInfoAlert}
              autoHideDuration={2000}
              onClose={handleInfoClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert variant="filled" onClose={handleInfoClose} severity="info">
                {infoAlertText}
              </Alert>
            </Snackbar>

    
          </div>
         </div>
       </div>
    </section>
  );
};
export default DetailBanque;
